import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { OrderResultContainer } from "./component/styled/setting";

const MenuBoardSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { cmpnyNo } = useParams();

  const search = new URLSearchParams(location.search);
  const paymentKey = search.get("paymentKey");
  const orderId = search.get("orderId");
  const amount = search.get("amount");
  const paymentType = search.get("paymentType");

  const requestedRef = useRef(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!paymentType && (!paymentKey || !orderId || !amount)) {
      // navigate(`/menu-board/${cmpnyNo}`);
      return;
    }
    if (!requestedRef.current) {
      requestedRef.current = true;
      confirmPayment();
    }
  }, []);

  const decryptId = async (id) => {
    const url = "/etc/decrypt-6char";
    const body = { code: id };
    const res = await axios.post(url, body);
    return res.data.plain;
  };

  const getCompany = async () => {
    const decryptedId = await decryptId(cmpnyNo);
    const url = "/erp/ss/company/get";
    const body = { cmpnyNo: decryptedId };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        const data = res.data;
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const confirmPayment = async () => {
    try {
      const items = JSON.parse(localStorage.getItem(`mbOrderItems:${cmpnyNo}`) || "[]");
      if (!Array.isArray(items) || !items.length) {
        console.log("items 없음");
        navigate(`/menu-board/${cmpnyNo}`);
        return;
      }

      // 주문 제출
      const orderSuccess = await submitOrder(items);
      if (!orderSuccess) {
        throw new Error("주문 제출 실패");
      }

      // 장바구니 정리
      await finalizeLocalOrder({ items });
    } catch (err) {
      console.error("결제 확인 실패:", err);
      navigate(`/menu-board/${cmpnyNo}`);
    } finally {
      setLoading(false);
    }
  };

  const getFirstImageUrl = (productImageUrl) => {
    try {
      if (!productImageUrl) return "";
      if (Array.isArray(productImageUrl)) {
        return productImageUrl[0] || "";
      }
      if (typeof productImageUrl === "string") {
        try {
          const parsed = JSON.parse(productImageUrl);
          if (Array.isArray(parsed)) {
            return parsed[0] || "";
          }
        } catch (_) {
          return productImageUrl || "";
        }
        return "";
      }
      // 알 수 없는 타입
      return "";
    } catch (_) {
      return "";
    }
  };

  const finalizeLocalOrder = async ({ items }) => {
    try {
      const key = `mbCart:${cmpnyNo}`;
      const raw = localStorage.getItem(key);
      const current = JSON.parse(raw || "[]");
      const orderIds = items.map((p) => p.id).filter(Boolean);

      const isSameOptions = (a = [], b = []) => {
        if (a.length !== b.length) return false;
        const sa = [...a].sort((x, y) => (x.optionId || 0) - (y.optionId || 0));
        const sb = [...b].sort((x, y) => (x.optionId || 0) - (y.optionId || 0));
        return sa.every(
          (x, i) =>
            (x.optionId || null) === (sb[i].optionId || null) &&
            (x.quantity || 1) === (sb[i].quantity || 1) &&
            (x.optionName || "") === (sb[i].optionName || ""),
        );
      };

      const shouldRemove = (cartItem) => {
        if (orderIds.includes(cartItem.id)) return true;
        const match = items.find(
          (o) =>
            o.vendorProductId === cartItem.vendorProductId &&
            isSameOptions(o.options || [], cartItem.options || []),
        );
        return Boolean(match);
      };

      const next = Array.isArray(current) ? current.filter((it) => !shouldRemove(it)) : [];
      localStorage.setItem(key, JSON.stringify(next));
    } finally {
      toast.success("주문이 완료되었습니다.");
      localStorage.removeItem(`mbOrderItems:${cmpnyNo}`);
      localStorage.removeItem(`mbTableNo:${cmpnyNo}`);
      localStorage.removeItem(`mbCart:${cmpnyNo}`);

      navigate(`/menu-board/${cmpnyNo}`);
    }
  };

  const submitOrder = async (items) => {
    try {
      const company = await getCompany();
      const decryptedId = await decryptId(cmpnyNo);
      const url = "/erp/ss/create";
      const tableNo = localStorage.getItem(`mbTableNo:${cmpnyNo}`);
      const decryptedtableNo = await decryptId(tableNo);

      // 주문 상품 데이터 구성
      const products = items.map((item) => ({
        options: (item.options || []).map((option) => ({
          optionId: option.optionId || null,
          optionName: option.name || "",
          quantity: option.quantity || 1,
          optionPrice: option.price || 0,
        })),
        price: item.productPrice || 0,
        quantity: item.quantity || 1,
        productName: item.productName || "",
        productImgSrc: getFirstImageUrl(item?.productImageUrl),
        productId: item.vendorProductId || null,
      }));

      const body = {
        input: {
          orderFlag: "SHOP",
          tableNo: decryptedtableNo || null,
          mberNm: "비회원",
          products: products,
          paymentType: paymentType || "APP",
          cmpnyLatitude: company.latitude,
          cmpnyLongitude: company.longitude,
          cmpnyLogo: company?.cmpnyImage?.[0] || "",
          cmpnyNm: company.cmpnyNm,
          cmpnyNo: decryptedId,
          cmpnyAdres: company?.addr || "",
          cmpnyDtlAdres: company?.addrDetail || "",
          cmpnyTelno: company?.tel || "",
        },
      };

      if (paymentKey && orderId) {
        body.input.paymentType = "APP";
        body.input.payments = {
          paymentKey: paymentKey,
          orderId: orderId,
        };
      }

      console.log("주문 데이터:", body);

      const res = await axios.post(url, body);
      if (res.status === 200) {
        console.log("주문 성공:", res.data);
        return true;
      } else {
        toast.error("주문 응답 오류");
        console.error("주문 응답 오류:", res.status);
        return false;
      }
    } catch (error) {
      toast.error("주문 제출 실패");
      console.error("주문 제출 실패:", error);
      return false;
    }
  };

  return (
    <OrderResultContainer>
      <strong>{loading ? "주문 처리 중입니다." : "주문이 완료되었습니다."}</strong>
    </OrderResultContainer>
  );
};

export default MenuBoardSuccess;
